// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QcHG","col":"styles_col__1kn_J"};